export interface ZadListQueryParams {
  search?: string
  isActive?: boolean | '' | 'true' | 'false'
  isPublished?: boolean | '' | 'true' | 'false'
  isFeatured?: boolean | '' | 'true' | 'false'
  category?: string
  productType?: string
  product?: string
  type?: string
  supplier?: string
  customer?: string
  createdBy?: string
  validatedBy?: string
  sale?: string
  status?: string
  archiveStatus?: string
  sourceType?: string
  paymentMethod?: string
  refundMethod?: string
  stockStatus?: string
  lowStockThreshold?: string | number
  startDate?: string
  endDate?: string
  pageNumber: number
  pageCount: number
  sortField?: string
  sortOrder?: string
}

export function buildZadListQuery(params: ZadListQueryParams): string {
  const query = new URLSearchParams()
  const pageNumber = params.pageNumber > 0 ? params.pageNumber : 1
  const pageCount = params.pageCount > 0 ? params.pageCount : 10

  query.set('pageNumber', String(pageNumber))
  query.set('pageCount', String(pageCount))
  query.set('sortField', params.sortField || 'createdAt')
  query.set('sortOrder', params.sortOrder || 'desc')

  if (params.search && params.search.trim()) {
    query.set('search', params.search.trim())
  }

  if (params.isActive === true || params.isActive === 'true') {
    query.set('isActive', 'true')
  } else if (params.isActive === false || params.isActive === 'false') {
    query.set('isActive', 'false')
  }

  if (params.isPublished === true || params.isPublished === 'true') {
    query.set('isPublished', 'true')
  } else if (params.isPublished === false || params.isPublished === 'false') {
    query.set('isPublished', 'false')
  }

  if (params.isFeatured === true || params.isFeatured === 'true') {
    query.set('isFeatured', 'true')
  } else if (params.isFeatured === false || params.isFeatured === 'false') {
    query.set('isFeatured', 'false')
  }

  if (params.category && params.category.trim()) {
    query.set('category', params.category.trim())
  }

  if (params.productType && params.productType.trim()) {
    query.set('productType', params.productType.trim())
  }

  if (params.product && params.product.trim()) {
    query.set('product', params.product.trim())
  }

  if (params.type && params.type.trim()) {
    query.set('type', params.type.trim())
  }

  if (params.supplier && params.supplier.trim()) {
    query.set('supplier', params.supplier.trim())
  }

  if (params.customer && params.customer.trim()) {
    query.set('customer', params.customer.trim())
  }

  if (params.createdBy && params.createdBy.trim()) {
    query.set('createdBy', params.createdBy.trim())
  }

  if (params.validatedBy && params.validatedBy.trim()) {
    query.set('validatedBy', params.validatedBy.trim())
  }

  if (params.sale && params.sale.trim()) {
    query.set('sale', params.sale.trim())
  }

  if (params.status && params.status.trim()) {
    query.set('status', params.status.trim())
  }

  if (params.archiveStatus && params.archiveStatus.trim()) {
    query.set('archiveStatus', params.archiveStatus.trim())
  }

  if (params.sourceType && params.sourceType.trim()) {
    query.set('sourceType', params.sourceType.trim())
  }

  if (params.paymentMethod && params.paymentMethod.trim()) {
    query.set('paymentMethod', params.paymentMethod.trim())
  }

  if (params.refundMethod && params.refundMethod.trim()) {
    query.set('refundMethod', params.refundMethod.trim())
  }

  if (params.stockStatus && params.stockStatus.trim()) {
    query.set('stockStatus', params.stockStatus.trim())
  }

  if (params.lowStockThreshold !== undefined && params.lowStockThreshold !== '') {
    query.set('lowStockThreshold', String(params.lowStockThreshold))
  }

  if (params.startDate && params.startDate.trim()) {
    query.set('startDate', params.startDate.trim())
  }

  if (params.endDate && params.endDate.trim()) {
    query.set('endDate', params.endDate.trim())
  }

  return query.toString()
}

export const DEFAULT_ZAD_LIST_PARAMS: ZadListQueryParams = {
  search: '',
  pageNumber: 1,
  pageCount: 10,
  sortField: 'createdAt',
  sortOrder: 'desc',
}
